import React, { Component } from 'react';
import { Container, Card, CardBody, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";

import SweetAlert from "react-bootstrap-sweetalert";

import { BaseUrl } from "../../helpers/Baseurl"


import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";

var include_id = 1

class TermsConditions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            termscondition:[],
            term_id:""
            
        }
    }

    async componentDidMount() {
        await this.loadTermsConditionData()
     }

    
    async loadTermsConditionData(){
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}`, },
            };
        await fetch(`${BaseUrl}/api/hotels/hotel-terms-conditions/?size=50&hotel__id=${this.props.hotel.id}`,requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    this.setState({ termscondition: data.results })
                        },
                    
                (error) => {
                    console.log(error, 'error------') 
                }
            )  
    }

    handleAddTermsRow(){
        const {termscondition} = this.state
        let newData = termscondition
        let newRow = {"id": `inc-${include_id}`, "point":""}
        newData.push(newRow)
        include_id = include_id+1
        this.setState({termscondition:newData})


    }

    handleDeleteIncludeRow(id){
        let new_id = ""+id
        const strFirstThree = new_id.substring(0,3)
        if (strFirstThree === "inc"){
            let new_data = []
            for (let i=0; i<this.state.termscondition.length;i++){
                if(this.state.termscondition[i].id !== id){
                    new_data.push(this.state.termscondition[i])
                }
            }
            
            this.setState({
                termscondition:new_data,
                term_id:"",
                success_confirm: true,
                alert_confirm : false,
                dynamic_title: "Deleted!",
                dynamic_description: "Row has been deleted."
                })

        }
        else {
            const requestOptions = {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${this.props.access}`, },
            };
            fetch(`${BaseUrl}/api/hotels/hotel-terms-conditions/${id}/`,requestOptions)
                .then(res => 
                    {if(res.status >= 400){
                        console.log("error")
                    }
                    else{
                        this.loadTermsConditionData()
                        this.setState({
                            term_id:"",
                            success_confirm: true,
                            alert_confirm : false,
                            dynamic_title: "Deleted!",
                            dynamic_description: "Row has been deleted."
                        })
                    }
                }
            )
        }

    }

    handleSaveTermsCondition = row => {
        let new_id = ""+row.id
        const strFirstThree = new_id.substring(0,3)
        let termsdata = {"point": row.point, "hotel": this.props.hotel.id}
        if (strFirstThree === "inc"){
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}`, },
                body: JSON.stringify(termsdata)
                };
                fetch(`${BaseUrl}/api/hotels/hotel-terms-conditions/`,requestOptions)
                      .then(res => 
                          {if(res.status >= 400){
                            this.loadTermsConditionData()
                              
                          }
                          else{
                            this.loadTermsConditionData()  
                          }    
                      }
                  )
        
        }else{
            const requestOptions = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}`, },
                body: JSON.stringify(termsdata)
                };
                fetch(`${BaseUrl}/api/hotels/hotel-terms-conditions/${row.id}/`,requestOptions)
                      .then(res => 
                          {if(res.status >= 400){
                            this.loadTermsConditionData()
                              
                          }
                          else{
                            this.loadTermsConditionData()  
                          }    
                      }
                  )
        }
    }   

    render() {
        const TermsColumn = [
            {
                dataField: "id",
                text: "id",
                hidden: true,
            },
            
            {
                dataField: "point",
                text: "Points",
                headerStyle: { backgroundColor: '#fcb92c', width: '90%' },
            },
            
            {
                dataField: "menu",
                isDummyField: true,
                text: "Action",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row, col) => 
                { 
                    return (
                        <React.Fragment>
                            <Link to="#" onClick={() => this.setState({ term_id: row.id, alert_confirm:true  })} className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>                    
                        </React.Fragment>
                      )
          
                }
              },
            ]
                  
        return (
            <React.Fragment>


          {/* <Breadcrumbs title={`Terms & Conditions`} breadcrumbItems={[]} /> */}
            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                  <h4 className="card-title">Terms & Conditions</h4>
                    <BootstrapTable
                        keyField="id"
                        data={this.state.termscondition}
                        columns={TermsColumn}
                        cellEdit={ cellEditFactory({    mode: 'dbclick',
                                                        blurToSave: true,
                                                        afterSaveCell: (oldValue, newValue, row, column) => { this.handleSaveTermsCondition(row) }
                                                        }) }
                    />
                    
                    <div style={{textAlign: "center"}}>
                        <Button color="secondary" outline className="waves-effect me-1 mb-3 "  onClick={() => this.handleAddTermsRow()}>
                            Add Terms & Conditions
                        </Button>
                    </div>

                  </CardBody>
                </Card>
              </Col>
             
            </Row>
        {this.state.alert_confirm ? (
                    <SweetAlert
                    title="Are you sure?"
                    warning
                    showCancel
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    onConfirm={() => this.handleDeleteIncludeRow(this.state.term_id)}
                    onCancel={() =>
                        this.setState({
                            alert_confirm: false,
                            term_id:"",

                        })
                    }
                    >
                    You won't be able to revert this!
                    </SweetAlert>
                    ) : null}

                    {this.state.success_confirm ? (
                    <SweetAlert
                    success
                    title={this.state.dynamic_title}
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    onConfirm={() => this.setState({ success_confirm: false, alert_confirm : false })}
                    >
                        {this.state.dynamic_description}
                    </SweetAlert>
                    ) : null
              }
      
      </React.Fragment>
        );
    }
}

export default TermsConditions;
